<script>
import { mapActions } from 'vuex';
import RbxFileList from '@/shared/reybex/RbxFileList';
import RbxFileUpload from '@/shared/reybex/RbxFileUpload';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'Documents',
  components: {
    RbxFileList,
    RbxFileUpload,
  },
  mixins: [snackbarMixin],
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      documents: [],
      isLoading: false,
      hasError: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    ...mapActions('attachment', ['fetchFileList']),
    onRemove() {
      this.fetchData();
    },
    onUploaded() {
      this.fetchData();
    },
    fetchData() {
      const { id } = this;

      this.isLoading = true;
      this.hasError = false;

      return this.fetchFileList({
        domain: 'affiliate/files',
        params: {
          id,
        },
      })
        .then(({ data }) => {
          console.log('data: ');
          console.log(data);
          this.documents = data;
        })
        .catch(() => {
          this.hasError = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<template>
  <div>
    <!--:acceptedTypes="'csv, doc, pdf, rtf, tex, txt, xlsx'"-->
    <RbxFileUpload
      domain="Affiliate"
      :reference-id="id"
      @uploaded="onUploaded"
    />
    <RbxFileList
      :file-list="documents"
      :loading="isLoading"
      @remove="onRemove"
    />
  </div>
</template>
